<template>
    <div id="inner">
        <b-row>
            <b-col>
                <p>
                    Hier vindt u brieven en algemene documenten die u vanuit Woonmatch ontvangen heeft. Brieven n.a.v. reacties op geadverteerde woningen vindt u bij ‘In behandeling’ of ‘Archief’.
                </p>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <div v-if="!finished" class="text-center">
                    <br/>
                    <h1>Bezig met laden...</h1>
                </div>
                <div v-else-if="letters.length === 0" class="text-center">
                    <br/>
                    <h1>Nog geen brieven</h1>
                </div>
                <div v-else class="archive" v-for="letter in letters" :key="letter.id">
                    <hr/>
                    <b-row>
                        <b-col cols="12">
                            <a
                                    :href="`../pdfreader.cfm?id=${letter.id}`"
                                    target="_blank"
                            >
                                {{letter.regDate.replace(' ', ' om ')}} - {{letter.title}}
                            </a>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import {reactionService} from "../../_services/reaction.service";

    export default {
        props: [
            'finished'
        ],
        data: () => {
            return {
                letters: []
            }
        },
        name: 'letterArchive',
        mounted() {
            reactionService.getLetters().then((data) => {
                this.letters = data;
            })
        },
        methods: {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .item-icon {
        width: 100px;
    }
</style>
